(function (ws) {
    'use strict';

    ws.views.searchPartNumber = ws.views.modal.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'quote',
        GTM_EVENT_ACTION: 'search_part_numbers',

        /**
         * Events
         */
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .qap-btn-add': 'addProductToQuote'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            this.$error = this.$('.qap-error');
            this.$emptyErrors = this.$('#qap-enter-partnumber .qap-bom-empty-fields');
            this.$globalErrors = $('.qut-global-error');
            this.$addProdErrors = $('.qap-addProd-validation-error-messages');
            this.$cartTableErrors = $('.qap-prod-validation-error-messages');
            this.$selectAllContainer = this.$('.select-all-container');
            this.$table = this.$('#qut-quotes-table');
            this.$emtpyTableCopy = this.$('.tbl-simple-empty-copy');
            this.$searchInput = this.$('.tbl-simple-searchInput');
            this.$addButton = this.$('.qap-btn-add');
            this.$showingPerPage = this.$('.tbl-simple-showing');
            this.$pagination = this.$('.pagination');

            ws.views.modal.prototype.initialize.call(this);

            this.on('onOpen', this.fetchDropdownsValues, this);

            this.$addButton.prop('disabled', true);
        },

        /**
         * add product to quote
         */
        addProductToQuote: function (ev) {
            ev.preventDefault();

            var $selectedCheckboxes = this.$('input[name="selectedProduct"]:checked');
            var selectedPartNumbers = _.map($selectedCheckboxes, function (each) {
                return $(each).val();
            });

            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, $('.cpt-filter-dropdown[name="vendor"]').val());
            this.eventAgg.trigger('ws.views.searchPartNumber:selectedPartNumbers', selectedPartNumbers);

            this.closeModal();
        },

        /**
         * Open browse catalog tab
         */
        fetchDropdownsValues: function() {
            this.eventAgg.trigger('qut-FetchAddProductDropdowns');
        },

        /**
         * closeModal override - apart from closing the modal, reset inputs and tabs to their initial state
         */
        closeModal: function () {
            // clear errors
            this.$error.css('visibility', 'hidden');

            // clear table
            this.$table.dataTable().fnClearTable();
            this.$table.DataTable().destroy();
            this.$emtpyTableCopy.hide();
            this.$searchInput.val('');
            this.$selectAllContainer.hide();
            this.$table.hide();
            this.$emtpyTableCopy.hide();

            this.$pagination.hide();
            this.$showingPerPage.hide();

            this.$cartTableErrors.find('span').hide();
            this.$addProdErrors.find('span').hide();

            // trigger super closeModal
            ws.views.modal.prototype.closeModal.call(this);

            this.$addButton.prop('disabled', true);
        }
    });
})(westcon);
